import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentComments: [],
  loading: false,
  error: false,
  message: null,
};

export const commentSlice = createSlice({
  name: "comment",
  initialState,
  reducers: {
    commentsFetchingStart: (state) => {
      state.loading = true;
    },
    commentsFetchingSuccess: (state, action) => {
      state.currentComments = action.payload;
      state.loading = false;
      state.error = false;
    },
    commentsFetchingFailure: (state) => {
      state.loading = false;
      state.error = false;
    },

    AddCommentStart: (state) => {
      state.loading = true;
    },
    AddCommentSuccess: (state, action) => {
      state.currentComments = [...state.currentComments, action.payload];
      state.loading = false;
      state.error = false;
    },
    AddCommentFailure: (state) => {
      state.loading = false;
      state.error = false;
    },
    deleteCommentStart: (state) => {
      state.loading = true;
    },
    deleteCommentSuccess: (state, action) => {
      state.message = action.payload;
      state.loading = false;
      state.error = false;
      state.currentComments.splice(
        state.currentComments.findIndex(
          (comment) => comment._id === action.payload.commentId
        ),
        1
      );
    },
    deleteCommentFailure: (state) => {
      state.loading = false;
      state.error = false;
    },
  },
});

export const {
  AddCommentStart,
  AddCommentSuccess,
  AddCommentFailure,
  commentsFetchingStart,
  commentsFetchingSuccess,
  commentsFetchingFailure,
  deleteCommentStart,
  deleteCommentSuccess,
  deleteCommentFailure,
} = commentSlice.actions;
export default commentSlice.reducer;
